/**
 * MediaPickerDialog — Phase 19-B
 *
 * Lightweight wrapper around the existing centralised <MediaLibrary />
 * component (release 1.C) that adds Dialog-based "kies uit Media Library"
 * UX. Uses the built-in `pickMode` of MediaLibrary so uploads + selection
 * already trigger the `onSelect` callback.
 *
 * Props:
 *   open: bool
 *   onOpenChange: (boolean) => void
 *   onSelect: (item) => void   // item = { id, url, filename, alt_text, ... }
 */
import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "../../ui/dialog";
import MediaLibrary from "../sections/MediaLibrary";

export default function MediaPickerDialog({ open, onOpenChange, onSelect }) {
  const handleSelect = (item) => {
    if (onSelect) onSelect(item);
    onOpenChange?.(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-5xl max-h-[90vh] overflow-hidden flex flex-col"
        data-testid="media-picker-dialog"
      >
        <DialogHeader>
          <DialogTitle>Media Library — kies of upload een afbeelding</DialogTitle>
          <DialogDescription>
            Upload vanaf uw computer of selecteer een bestaande afbeelding.
            Toegestaan: PNG, JPG, WEBP, GIF — max 5 MB.
          </DialogDescription>
        </DialogHeader>
        <div className="overflow-y-auto flex-1 -mx-6 px-6">
          <MediaLibrary pickMode onSelect={handleSelect} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
